import React from 'react';
import { motion } from 'framer-motion';
import { Cloud } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLocalStorageState } from '@/hooks/ai-agents/useLocalStorageState';

const StorageButton = () => {
  const navigate = useNavigate();
  const { isModalOpen, closeModal } = useLocalStorageState();
  
  const handleClick = () => {
    // Close chat modal if it's open (same pattern as other navbar buttons)
    if (isModalOpen) {
      closeModal();
    }
    navigate('/storage');
  };
  
  return (
    <motion.div
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="relative"
    >
      <button
        onClick={handleClick}
        className={`
          h-9 w-9 rounded-lg group p-0
          flex items-center justify-center 
          bg-gradient-to-br from-blue-500 to-purple-600
          hover:from-blue-600 hover:to-purple-700
          transition-all duration-200
          shadow-md hover:shadow-lg
        `}
        aria-label="Storage"
      >
        <motion.div
          whileHover={{ scale: 1.1, rotate: 5 }}
          transition={{ duration: 0.3 }}
        >
          <Cloud size={18} className="text-white" />
        </motion.div>
      </button>
    </motion.div>
  );
};

export default StorageButton; 